import { BankRepository } from "../infra/SettingsRepository";
export class GetBankSettingsQuery {

    constructor(private readonly repository: BankRepository, private readonly frontend){ }

    async run(user_id: number): Promise <void> { 
        let settings = await this.repository.find_settings_by_user_id(user_id) 
        if (settings) {
            this.frontend.bankSetting = settings
            this.frontend.bankDialogHide = settings['payload'] && settings['payload']['hide'] ? settings['payload']['hide']:[]
            this.frontend.bankDialogShow = settings['payload'] && settings['payload']['hide'] ? settings['payload']['show']:[]
            this.frontend.popupBankDialog = true
        }
    }
}